import AppLogo from "@/assets/app-logo.svg";
import ReleaseDate from "@/fragments/ReleaseDate";
import {
  AccountCircle,
  AutoStories,
  Close,
  Security,
  ContactSupport,
  Logout,
  SwitchAccount,
  Verified,
} from "@mui/icons-material";
import {
  Avatar,
  Box,
  Container,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useCurrentUser } from "@/services/hooks";
import { handleLogout } from "@/utils";

const outlinedStyle = {
  border: 1,
  borderColor: "#04FFFF",
  borderStyle: "solid",
};

export default function CurrentUserDrawer() {
  const navigate = useNavigate();
  const { data: currentUser } = useCurrentUser();

  const [drawerOpen, setDrawerOpen] = useState(false);

  return (
    <Box>
      <Box
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
        }}
        onClick={() => setDrawerOpen(!drawerOpen)}
        sx={{ width: "44px" }}
      >
        {currentUser?.role === "artist" && (
          <Verified
            color={currentUser?.verified ? "secondary" : "disabled"}
            style={{ fontSize: "15px", marginRight: "5px" }}
          />
        )}

        <Avatar
          src={currentUser?.meta?.profile}
          sx={{ width: 30, height: 30 }}
          style={currentUser?.role == "artist" ? outlinedStyle : {}}
        />
      </Box>

      <Drawer
        anchor="bottom"
        open={drawerOpen}
        onClose={() => setDrawerOpen(!drawerOpen)}
        style={{ zIndex: 1000 }}
        PaperProps={{ style: { borderRadius: "20px 20px 0 0" } }}
        elevation={10}
      >
        <Container maxWidth="sm">
          <Box
            role="presentation"
            onClick={() => setDrawerOpen(!drawerOpen)}
            onKeyDown={() => setDrawerOpen(!drawerOpen)}
            // style={{ background: "#121212" }}
            sx={{ pb: 5, pl: 0, pr: 1 }}
          >
            <Box
              sx={{
                my: 4,
                ml: 1,
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <IconButton onClick={() => setDrawerOpen(!drawerOpen)}>
                <Close />
              </IconButton>
              <img
                src={AppLogo}
                alt="notebook-logo"
                style={{ width: 160, opacity: 0.95 }}
                sx={{ mb: 2 }}
              />
              <Box sx={{ width: 40 }} />
            </Box>

            {/* <CopyLink /> */}

            <List sx={{ my: 2 }}>
              {currentUser?.admin === true && (
                <>
                  <ListItem
                    key="admin"
                    onClick={() => navigate("/console")}
                    sx={{ cursor: "pointer" }}
                  >
                    <ListItemIcon>
                      <Security color="secondary" />
                    </ListItemIcon>
                    <ListItemText primary="Admin Console" />
                  </ListItem>
                </>
              )}
              <ListItem
                key="profile"
                onClick={() => navigate("/account")}
                sx={{ cursor: "pointer" }}
              >
                <ListItemIcon>
                  <AccountCircle />
                </ListItemIcon>

                <Box
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    width: "100%",
                  }}
                  sx={{ my: 0.5 }}
                >
                  <Typography>My Account</Typography>

                  {currentUser?.role === "artist" ? (
                    <Box>
                      <Verified color="secondary" />
                    </Box>
                  ) : (
                    <Box />
                  )}
                </Box>
              </ListItem>

              <ListItem
                key="subscriptions"
                onClick={() => navigate("/subscriptions")}
                sx={{ cursor: "pointer" }}
              >
                <ListItemIcon>
                  <AutoStories />
                </ListItemIcon>
                <ListItemText primary="Artist Subscriptions" />
              </ListItem>

              {true && (
                <ListItem
                  key="accounts"
                  onClick={() => navigate("/accounts")}
                  sx={{ cursor: "pointer" }}
                >
                  <ListItemIcon>
                    <SwitchAccount />
                  </ListItemIcon>
                  <ListItemText primary="Accounts" />
                </ListItem>
              )}

              <ListItem
                key="support"
                onClick={() => navigate("/contact")}
                sx={{ cursor: "pointer" }}
              >
                <ListItemIcon>
                  <ContactSupport />
                </ListItemIcon>
                <ListItemText primary="Contact" />
              </ListItem>

              <ListItem
                key="Logout"
                onClick={handleLogout}
                sx={{ cursor: "pointer" }}
              >
                <ListItemIcon>
                  <Logout />
                </ListItemIcon>
                <ListItemText primary="Logout" />
              </ListItem>
            </List>

            <Box
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {/* <Box sx={{ my: 2 }}>
                <img
                  src={AppLogo}
                  style={{
                    width: "250px",
                    display: "block",
                    margin: "auto",
                    opacity: 0.5,
                  }}
                />
              </Box> */}
              <ReleaseDate />
            </Box>
          </Box>
        </Container>
      </Drawer>
    </Box>
  );
}
